// extracted by mini-css-extract-plugin
module.exports = {"ArtistPage":"ArtistPage_ArtistPage__35ptE","ImgWrapper":"ArtistPage_ImgWrapper__2VcZ6","about":"ArtistPage_about__AYCoP"};